"use strict";

exports.__esModule = true;
exports.default = pluckProps;

var _object = require("./object");

var _array = require("./array");

var _identity = require("./identity");

/**
 * Given an array of properties or an object of property keys,
 * plucks all the values off the target object.
 * @param {{}|string[]} keysToPluck
 * @param {{}} objToPluck
 * @param {Function} transformFn
 * @return {{}}
 */
function pluckProps(keysToPluck, objToPluck) {
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity.default;
  return ((0, _array.isArray)(keysToPluck) ? keysToPluck.slice() : (0, _object.keys)(keysToPluck)).reduce(function (memo, prop) {
    // eslint-disable-next-line no-sequences
    return memo[transformFn(prop)] = objToPluck[prop], memo;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/pluck-props.js
// module id = 118
// module chunks = 0